import PdfProofRequest from "./PdfProofRequest"
import PdfProofResponse from "./PdfProofResponse"
import ProofUrlResponse from "./ProofUrlResponse"
import http from "../../utils/httpClient"
import {Buffer} from "buffer"
import {getAccessToken} from "../../utils/auth"
import {getErrorMessage, getErrorStatusCode} from "../../utils/errorHandler"
import {DesignServiceDependency, PdfProofActionTypes} from "../../services/designService/designService"

const prepressUrl =
	"https://prepress.documents.cimpress.io/v2/print-prep?asynchronous=true&noredirect=true"
const APIParamsUrl = "https://pdf-proof.care.vpsvc.com/api_params.json"

export default class PdfProofService {
	pdfProofResponse: PdfProofResponse
	pdfProofRespAsync: PdfProofResponse
	completed: boolean
	constructor() {
		this.pdfProofResponse = new PdfProofResponse()
		this.completed = false
		this.pdfProofRespAsync = new PdfProofResponse()
	}
	FormPdfProofRequest(AltDocId: string, useWaterMark: boolean, PrepressInstructionsUrl: string) {
		let pdfProofRequest = new PdfProofRequest()
		pdfProofRequest.prepressInstructionsUrl = PrepressInstructionsUrl
			? PrepressInstructionsUrl
			: `https://udsinterop.document.vpsvc.com/api/vpdoc/prod/${AltDocId}?document_mode=vistaprintcanonical&strip_image_frames_from_uploads=true&missing_upload_placeholder_url=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fcommons%2F8%2F89%2FHD_transparent_picture.png&return=drawingInstructions`
		if (useWaterMark) pdfProofRequest.ParametersUrl = APIParamsUrl
		return pdfProofRequest
	}

	PreviewPdf() {
		return fetch(this.pdfProofResponse.Output, {
			method: "get",
		})
			.then((res) => res.json())
			.then(
				async (result) => {
					let proofUrlResponse = new ProofUrlResponse()
					proofUrlResponse = result
					var card = document.getElementById("card_pdf_preview") as HTMLElement

					var iframe = document.getElementById("pdf_preview") as HTMLFrameElement
					if (iframe != null) {
						iframe.src = proofUrlResponse.PdfUrl
						card.style.visibility = "visible"
					}
					return await this.getBinary(proofUrlResponse.PdfUrl)
				},
				(error) => {
					console.log(error)
				}
			)
	}


	async getBinary(url: string){
		return await http.get(url, { responseType: 'arraybuffer' })
		.then((response: any) => {
			const base64data = Buffer.from(response.data, 'binary').toString('base64');
			return base64data
		})
		.catch((error: any) => {
		console.log(error);
		});
	}

	/*GetError(){
      fetch(
        this.pdfProofResponse.ResultUrl,
        {
          method: 'get',
        })
      .then(res => res.json())
      .then(
          (result) => {
            console.log(result.Exception.Message);
            var errorLabel = document.getElementById("error-label") as HTMLElement;
            errorLabel.innerText = result.Exception.Message;     
            errorLabel.style.visibility = 'visible';
          },
          (error) => {
            console.log(error)
          }
      )  
    }*/

	public async GeneratePdfProofAsync(
		AltDocId: string,
		useWaterMark: boolean,
		PrepressInstructionsUrl: string
	) {
		var card = document.getElementById("card_pdf_preview") as HTMLElement
		card.style.visibility = "hidden"
		var errorLabel = document.getElementById("error-label") as HTMLElement
		errorLabel.style.visibility = "hidden"
		console.log(prepressUrl)
		return await fetch(prepressUrl, {
			method: "post",
			cache: "no-cache",
			headers: {
				Authorization: `Bearer ${getAccessToken()}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(
				this.FormPdfProofRequest(AltDocId, useWaterMark, PrepressInstructionsUrl)
			),
		})
			.then((res) => res.json())
			.then(
				async (result) => {
					DesignServiceDependency.logAction(PdfProofActionTypes.GenerateProof)
					return await this.GetReadyPdf(result)
				},
				(error) => {
					DesignServiceDependency.logAction(PdfProofActionTypes.GenerateProofFailure, {
						status: getErrorStatusCode(error),
						message: getErrorMessage(error)
					})
					console.log("error")
				}
			)
			.catch(e => {
				DesignServiceDependency.logAction(PdfProofActionTypes.GenerateProofFailure, {
					status: getErrorStatusCode(e),
					message: getErrorMessage(e)
				})
			})
	}

	private async GetReadyPdf(result: any) {
		this.pdfProofResponse = result
		do {
			await this.delay(10000)
			this.pdfProofResponse = await http.get(this.pdfProofResponse.ResultUrl).then((res: any) => {
				return res.data
			})
		} while (
			this.pdfProofResponse.Status === "Starting" ||
			this.pdfProofResponse.Status === "Creating"
		)

		if (
			this.pdfProofResponse.Status !== undefined &&
			this.pdfProofResponse.Status === "Completed"
		) {
			this.completed = true
			return this.PreviewPdf()
		} else {
			//this.GetError();
			var errorLabel = document.getElementById("error-label") as HTMLElement
			errorLabel.innerText =
				"An error has occurred while generating your PDF. If you manually entered information above, please double check it. Otherwise this may be related to a large backlog of requests to the PDF Processor within the plant - check with Care in Manufacturing to determine if an outage is occurring."
			errorLabel.style.visibility = "visible"
		}
		this.completed = true
	}

	public delay(ms: number) {
		return new Promise((resolve) => setTimeout(resolve, ms))
	}
}
